import { render } from "./bed_setting.vue?vue&type=template&id=dbaf11fe&scoped=true"
import script from "./bed_setting.vue?vue&type=script&lang=js"
export * from "./bed_setting.vue?vue&type=script&lang=js"

import "./bed_setting.vue?vue&type=style&index=0&id=dbaf11fe&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbaf11fe"]])

export default __exports__